import React, { ReactElement, useEffect, useRef } from "react";

interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  content: React.ReactNode;
  children: ReactElement;
  placement?: "bottomLeft" | "topLeft" | "topRight" | "bottomRight";
  mode?: "light" | "dark"
  className?: string;
}

const Popover: React.FC<IProps> = ({ visible, setVisible, content, children, placement = "bottomLeft", mode = "light", className }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setVisible(false);
    }
  };

  const handleShow = () => {
    setVisible((pre) => !pre);
  };

  return (
    <div ref={ref} className="relative">
      <div onClick={handleShow}>{children}</div>
      {visible && (
        <div
          className={`absolute ${placement.includes("bottom") ? "top-[calc(100%+3px)]" : "bottom-[calc(100%+8px)]"
            } left-0 shadow-[0_4px_16px_0px_#191D261F] ${mode === "light" ? "bg-white" : "bg-#191D26E5"} z-10 rounded-1.5 px-2 py-2 ${placement.includes("Right") && "left-unset right-0"} ${className}`}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Popover;
